import { NODE_TYPES } from '@services/conditionEngine/constants';
import evaluatorRegistry from '@services/conditionEngine/evaluators/registry';

const trueEvaluator = () => true;

evaluatorRegistry.registerEvaluatorForNodeType(NODE_TYPES.TRUE, trueEvaluator);
export default trueEvaluator;
